import { showModal } from '@/share/actions'
import React from 'react'
import ReactDOM from 'react-dom'
import IllustrateMod from './illustrateMod'

class IllustrateBubble {
  private dom: HTMLElement
  private visible = false
  private createTemIsFirst = false
  private editor
  private from
  private to
  private class
  private top
  private nodePos
  private isAllComplete = true
  private isModalShow = true
  constructor(mountEle: HTMLElement) {
    this.dom = document.createElement('div')
    this.dom.style.position = 'absolute'
    this.dom.id = 'illustrateWrapper'
    mountEle.appendChild(this.dom)
  }

  public show = (
    top: number,
    paragraphSign: string,
    editor,
    illustrateHas: boolean, //是否有说明
    nodePos: number,
    list?: any,
  ) => {
    this.editor = editor
    this.visible = true
    this.class = paragraphSign
    this.top = top
    this.nodePos = nodePos
    this.dom.style.right =
      localStorage.getItem('isFullDisplay') == 'true' ||
      localStorage.getItem('showRight') == 'true'
        ? `0`
        : '-340px'
    this.dom.style.top = `${top}px`
    this.dom.style.display = 'block'
    this.dom.style.background = '#fff'
    ReactDOM.render(
      <IllustrateMod
        domId="illustrateBubble"
        top={top}
        key={paragraphSign + Date.now()}
        paragraphSign={paragraphSign}
        onIsAllComplete={this.isAllCompleteHandle}
        onFirstSubmit={this.firstSubmitHandle}
        illustrateHas={illustrateHas}
        nodePos={nodePos}
        list={list ? list : []}></IllustrateMod>,
      this.dom,
    )
  }

  public isAllCompleteHandle = (isAllComplete) => {
    this.isAllComplete = isAllComplete
  }

  public firstSubmitHandle = (isFirst, list) => {
    this.createTemIsFirst = true
    this.show(this.top, this.class, this.editor, false, this.nodePos, list)
    // this.dom.style.display = 'block'
  }

  public hide = () => {
    var modal = document.getElementsByClassName('arco-confirem-model')
    if (this.isAllComplete == false && modal.length == 0) {
      showModal('ConfirmModal', {
        title: '隐藏说明气泡',
        content: `还有未完成的模版，确定隐藏说明气泡？`,

        onConfirm: () => {
          this.dom.style.display = 'none'
          this.visible = false
          this.isAllComplete = true
        },
        onCancel: () => {
          this.isAllComplete = false
        },
      })
      return
    }

    this.dom.style.display = 'none'
    this.visible = false
  }

  get isVisible() {
    return this.visible
  }
}

export { IllustrateBubble }
